import { pipe } from "ramda";

import { FILETYPE_TO_EXTENSION_MAP } from "./enums";

const convertStringToArray = (files) =>
  Object.values(JSON.parse(files)).map((file) => file.src);

export const convertBlobsToFiles = async (files) => {
  try {
    const convertedFiles = await Promise.all(
      files.map(async (file, index) => {
        const fetchedFile = await fetch(file);
        const blob = await fetchedFile.blob();

        return new File(
          [blob],
          `image-${index}.${FILETYPE_TO_EXTENSION_MAP[blob.type]}`
        );
      })
    );

    return convertedFiles;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default pipe(convertStringToArray, convertBlobsToFiles);
